<h2 class="title">Najnowsze wieści z ZGranego Grona</h2>

@if (!loading && news.length > 0) {
  <div>
    <div class="news-list">
      @for (item of news; track item) {
        <app-news-list-item
          [news]="item"
          class="news-item">
        </app-news-list-item>
      }
    </div>
    @if (hasMore) {
      <div class="news-load-more">
        <button mat-raised-button class="custom-button" (click)="loadNextPage()" [disabled]="loadingMore">
          @if (loadingMore) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          @if (!loadingMore) {
            <mat-icon>expand_more</mat-icon>
          }
          {{ loadingMore ? 'Pobieranie...' : 'Załaduj kolejne 50 wiadomości' }}
        </button>
      </div>
    }
    @if (!hasMore) {
      <div class="no-more">
      </div>
    }
  </div>
}

@if (loading) {
  <div class="loading">
    Pobieranie najnowszych wieści...
  </div>
}

@if (!loading && news.length === 0) {
  <div class="loading">
    Brak wiadomości do wyświetlenia.
  </div>
}